import { CertificationCatalogItemMultiLang } from 'types/types.types';
import { EMPTY_MULTI_LANG_FIELD } from './Language';

export const EMPTY_CERTIFICATION: CertificationCatalogItemMultiLang = {
  id: '',
  imageUrl: '',
  title: EMPTY_MULTI_LANG_FIELD,
  description: EMPTY_MULTI_LANG_FIELD,
};
